import {sleep, Future} from "./async";

let toastLayer: HTMLDivElement|null = null;

export function init() {
    toastLayer = document.createElement("div");
    toastLayer.id = "toast-layer";
    document.body.appendChild(toastLayer);
}

export async function send(type: string, text: string) {
    if (toastLayer === null) {
        return;
    }

    const toastElement = document.createElement("div");
    toastElement.classList.add("toast", type, "transparent");
    toastElement.textContent = text;
    toastLayer.appendChild(toastElement);

    // Wait for the toast to render with opacity 0
    await sleep(100);

    toastElement.style.opacity = "1";

    // Wait for the user to have time to read the toast
    await sleep(5000);

    toastElement.style.opacity = "0";

    // Wait for the fade out to complete
    await sleep(600);

    toastElement.remove();
}


export async function sendPersistent(type: string, text: string) {
    if (toastLayer === null) {
        return;
    }

    const future = new Future<null>();

    const toastElement = document.createElement("div");
    toastElement.classList.add("toast", type, "transparent");
    toastElement.textContent = text;
    toastElement.addEventListener("click", () => {
        future.resolve(null);
    });
    toastLayer.appendChild(toastElement);

    // Wait for the toast to render with opacity 0
    await sleep(100);

    toastElement.style.opacity = "1";

    // Wait for the user to click on the toast
    await future;

    toastElement.style.opacity = "0";

    // Wait for the fade out to complete
    await sleep(600);

    toastElement.remove();
}
